<template>
  <div class="custom-input text">
    <div class="input-inner">
      <div v-if="label" :class="getLabelClass">{{ $t(label) }}</div>

      <b-input-group>
        <b-form-file v-model="val" :required="required" :accept="types"
                     :placeholder="$t(placeholder)" :drop-placeholder="dropPlaceholder"
                     :browse-text="$t('_browse')"
        >
          <template slot="file-name" slot-scope="{ names }">
            <b-badge class="orange-white">{{ names[0] }}</b-badge>
          </template>
        </b-form-file>

        <template #append>
          <base-button v-if="val" fa-class="trash" @click="val = null" />
        </template>
      </b-input-group>
    </div>
  </div>
</template>

<script>
import error from '@/components/frontoffice/form/error'
import formMethods from '@/components/frontoffice/mixins/formMethods'
import baseButton from '@/components/backoffice/button/base'

export default {
  components: {
    error,
    baseButton
  },

  mixins: [formMethods],

  props: {
    value: {
      type: [String,File]
    },
    required: {
      type: Boolean,
      default: false
    },
    label: String,
    placeholder: {
      type: String,
      default:'fileInput.placeholder'
    },
    types: String
  },


  data () {
    return {
      val: this.value,
      //placeholder: this.$t('fileInput.placeholder'),
      dropPlaceholder: this.$t('fileInput.drop')
    }
  },

  watch: {
    value (newVal) {
      this.val = newVal
    },

    val (newVal) {
      this.$emit('input', newVal)
    }
  }
}
</script>
